export const EPARGN_PRODUCT_SCR = 801;
export const EPARGN_PRODUCT_SCR_NAME = 'Assurance vie SCR';
